<template>
  <b-modal
    v-model="modal"
    :title="title"
    size="xl"
    :no-enforce-focus="true"
    :no-close-on-backdrop="true"
  >
    <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
    </loading>
    <div class="row">
      <div class="col-lg-12">
        <b-tabs justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
          <b-tab active>
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-home"></i>
              </span>
              <span class="d-none d-sm-inline-block">Detalhes</span>
            </template>

            <div role="tablist">
              <!-- MODO CARD BUILDER (mesmo padrão do Form.vue) -->
              <template v-if="participantCard && visibleCardTabs.length > 0">
                <b-card
                  v-for="(tab, tabIndex) in visibleCardTabs"
                  :key="`card-tab-${tab.id}`"
                  no-body
                  class="mb-1 shadow-none"
                >
                  <b-card-header header-tag="header" role="tab">
                    <h6 class="m-0 d-flex justify-content-between align-items-center">
                      <a
                        :href="`#collapse-card-tab-${tab.id}`"
                        v-b-toggle="`accordion-card-tab-${tab.id}`"
                        class="text-dark"
                      >{{ tab.name }}</a>
                      <i
                        class="bx bx-chevron-down chevron-icon"
                        v-b-toggle="`accordion-card-tab-${tab.id}`"
                      ></i>
                    </h6>
                  </b-card-header>
                  <b-collapse
                    :id="`accordion-card-tab-${tab.id}`"
                    :visible="tabIndex === 0"
                    accordion="card-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <form autocomplete="off">
                        <div class="row">
                          <template v-for="field in tab.fields">
                            <div
                              v-if="isFieldVisible(field)"
                              :key="`card-field-${field.id}`"
                              :class="`col-sm-${getCardFieldSize(field)}`"
                            >
                              <component
                                :is="getCardFieldComponent(field)"
                                :id="field.id"
                                :value="customDataValues[getCardFieldKey(field)] || ''"
                                :label="getCardFieldLabel(field)"
                                :placeholder="field.placeholder || ''"
                                :options="getCardFieldOptions(field)"
                                classInput="col-sm-12"
                                :isRequired="field.is_required"
                                @input="updateCustomDataValue(getCardFieldKey(field), $event)"
                              />
                            </div>
                          </template>
                        </div>
                      </form>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </template>

              <!-- FALLBACK: CAMPOS BÁSICOS (quando não há card builder) -->
              <template v-if="!participantCard && !loadingCard">
                <b-card no-body class="mb-1 shadow-none">
                  <b-card-header header-tag="header" role="tab">
                    <h6 class="m-0">
                      <a
                        v-b-toggle.dados-basicos
                        class="text-dark"
                        href="javascript: void(0);"
                      >Dados Cadastrais</a>
                      <b-badge
                        v-show="submitted && (!companion.name || !companion.email)"
                        variant="danger"
                        class="float-right"
                      >
                        Atenção! Existem campos a serem preenchidos.
                      </b-badge>
                    </h6>
                  </b-card-header>
                  <b-collapse id="dados-basicos" visible accordion="companion-accordion" role="tabpanel">
                    <b-card-body>
                      <form autocomplete="off">
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>Nome completo <span class="text-danger">*</span></label>
                              <input v-model="companion.name" type="text" class="form-control"
                                :class="{ 'is-invalid': submitted && !companion.name }" />
                              <div v-if="submitted && !companion.name" class="invalid-feedback">Campo obrigatório.</div>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>E-mail <span class="text-danger">*</span></label>
                              <input v-model="companion.email" type="email" class="form-control"
                                :class="{ 'is-invalid': submitted && !companion.email }" />
                              <div v-if="submitted && !companion.email" class="invalid-feedback">Campo obrigatório.</div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-4">
                            <div class="form-group">
                              <label>Telefone</label>
                              <input v-model="companion.phone" type="text" v-mask="'(##) #####-####'" class="form-control" />
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="form-group">
                              <label>CPF</label>
                              <input v-model="companion.cpf" v-mask="'###.###.###-##'" type="text" class="form-control"
                                @change="validCPF()" :class="{ 'is-invalid': errorCPF }" />
                              <div v-if="errorCPF" class="invalid-feedback">CPF inválido.</div>
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="form-group">
                              <label>Data Nascimento</label>
                              <input v-model="companion.birth_date" type="date" class="form-control" />
                            </div>
                          </div>
                        </div>
                      </form>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </template>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="close()">Cancelar</b-button>
      <button type="submit" class="btn btn-primary mr-1" @click="saveCompanion()">Salvar</button>
    </template>
  </b-modal>
</template>
<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { states } from './statesData'
import Multiselect from 'vue-multiselect'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { cpf } from 'cpf-cnpj-validator'
import http from '@/http'
import BaseInput from '@/components/formSchema/BaseInput'
import BaseInputEmail from '@/components/formSchema/BaseInputEmail'
import BaseInputPhone from '@/components/formSchema/BaseInputPhone'
import BaseSelect from '@/components/formSchema/BaseSelect'
import BaseRadio from '@/components/formSchema/BaseRadio'
import BaseTextArea from '@/components/formSchema/BaseTextArea'
import BaseInputDate from '@/components/formSchema/BaseInputDate'
import BaseInputCPF from '@/components/formSchema/BaseInputCPF'
import BaseInputCNPJ from '@/components/formSchema/BaseInputCNPJ'
import BaseMultiselect from '@/components/formSchema/BaseMultiselect'

export default {
  components: {
    Loading,
    Multiselect,
    BaseInput,
    BaseInputEmail,
    BaseInputPhone,
    BaseSelect,
    BaseRadio,
    BaseTextArea,
    BaseInputDate,
    BaseInputCPF,
    BaseInputCNPJ,
    BaseMultiselect
  },
  props: {
    idParticipant: {
      type: [Number, String],
      default: null
    }
  },
  data () {
    return {
      title: 'Cadastrar Acompanhante',
      loading: false,
      loadingCard: false,
      errorCPF: false,
      submitted: false,
      states: states,
      companion: {},
      modal: false,
      participantCard: null,
      customDataValues: {}
    }
  },
  computed: {
    visibleCardTabs () {
      if (!this.participantCard || !this.participantCard.tabs) return []
      return this.participantCard.tabs.filter(tab => tab.fields && tab.fields.length > 0)
    },
    hasCardBuilder () {
      return this.participantCard && this.visibleCardTabs.length > 0
    }
  },
  methods: {
    validCPF () {
      if (!this.companion.cpf) {
        this.errorCPF = false
        return
      }
      this.errorCPF = !cpf.isValid(this.companion.cpf)
    },
    async loadCompanionCard (participantId) {
      this.loadingCard = true
      try {
        const response = await http.get(`/admin/companions/${participantId}/card`)
        const data = response.data
        if (data && data.tabs && data.tabs.length > 0) {
          this.participantCard = data
        } else {
          this.participantCard = null
        }
      } catch (err) {
        console.warn('Não foi possível carregar ficha do acompanhante:', err)
        this.participantCard = null
      } finally {
        this.loadingCard = false
      }
    },
    open (participantId = null) {
      this.modal = true
      this.loading = false
      this.submitted = false
      this.errorCPF = false
      this.companion = {}
      this.customDataValues = {}
      this.participantCard = null

      if (participantId) {
        this.loadCompanionCard(participantId)
      }
    },
    updateCustomDataValue (fieldName, value) {
      this.$set(this.customDataValues, fieldName, value)
    },

    // ---- Métodos do Card Builder (mesma lógica do Form.vue) ----

    getCardFieldKey (field) {
      if (field.field_source === 'standard') {
        return field.standard_field_name
      }
      if (field.field_source === 'form_field' && field.form_field) {
        return field.form_field.name || ('field_' + field.form_field.id)
      }
      if (field.field_source === 'internal') {
        return (field.field_config && field.field_config.name) || ('internal_' + field.id)
      }
      return 'field_' + field.id
    },
    getCardFieldComponent (field) {
      if (field.field_source === 'standard') {
        const map = {
          name: 'BaseInput',
          email: 'BaseInputEmail',
          cpf: 'BaseInputCPF',
          phone: 'BaseInputPhone',
          gender: 'BaseSelect',
          birth_date: 'BaseInputDate',
          address: 'BaseInput',
          city: 'BaseInput',
          state: 'BaseSelect',
          zip_code: 'BaseInput',
          country: 'BaseInput'
        }
        return map[field.standard_field_name] || 'BaseInput'
      }
      if (field.field_source === 'form_field' && field.form_field && field.form_field.field_type) {
        return this.mapComponentName(field.form_field.field_type.component || 'TextField')
      }
      if (field.field_source === 'internal' && field.field_config) {
        const map = {
          text: 'BaseInput',
          textarea: 'BaseTextArea',
          number: 'BaseInput',
          select: 'BaseSelect',
          multiselect: 'BaseMultiselect',
          checkbox: 'BaseRadio',
          radio: 'BaseRadio',
          date: 'BaseInputDate',
          datetime: 'BaseInputDate',
          toggle: 'BaseRadio'
        }
        return map[field.field_config.field_type] || 'BaseInput'
      }
      return 'BaseInput'
    },
    getCardFieldOptions (field) {
      if (field.field_source === 'standard') {
        if (field.standard_field_name === 'gender') {
          return [
            { value: 'Masculino', label: 'Masculino' },
            { value: 'Feminino', label: 'Feminino' },
            { value: 'Não-binário', label: 'Não-binário' },
            { value: 'Outro', label: 'Outro' },
            { value: 'Prefiro não informar', label: 'Prefiro não informar' }
          ]
        }
        if (field.standard_field_name === 'state') {
          return this.states || []
        }
      }
      if (field.field_source === 'form_field' && field.form_field) {
        return field.form_field.options || []
      }
      if (field.field_source === 'internal' && field.field_config && field.field_config.options) {
        return field.field_config.options
      }
      return []
    },
    getCardFieldLabel (field) {
      if (field.field_config && field.field_config.label_override) {
        return field.field_config.label_override
      }
      if (field.label) return field.label
      if (field.field_source === 'standard') {
        const labels = {
          name: 'Nome Completo',
          email: 'E-mail',
          cpf: 'CPF',
          phone: 'Telefone',
          gender: 'Gênero',
          birth_date: 'Data de Nascimento',
          address: 'Endereço',
          city: 'Cidade',
          state: 'Estado',
          zip_code: 'CEP',
          country: 'País'
        }
        return labels[field.standard_field_name] || field.standard_field_name
      }
      if (field.field_source === 'form_field' && field.form_field) {
        return field.form_field.label || field.form_field.name
      }
      if (field.field_source === 'internal' && field.field_config) {
        return field.field_config.label || field.field_config.name
      }
      return 'Campo'
    },
    getCardFieldSize (field) {
      if (field.layout && field.layout.cols) {
        return field.layout.cols
      }
      return 6
    },
    isFieldVisible (field) {
      if (field.is_visible === false) return false
      return true
    },
    mapComponentName (componentName) {
      const componentMap = {
        'TextField': 'BaseInput',
        'NumberField': 'BaseInput',
        'UrlField': 'BaseInput',
        'HiddenField': 'BaseInput',
        'CurrencyBrlField': 'BaseInput',
        'DecimalField': 'BaseInput',
        'RgField': 'BaseInput',
        'CepField': 'BaseInput',
        'AddressField': 'BaseInput',
        'CityField': 'BaseInput',
        'TextareaField': 'BaseTextArea',
        'TextAreaField': 'BaseTextArea',
        'EmailField': 'BaseInputEmail',
        'PhoneField': 'BaseInputPhone',
        'CpfField': 'BaseInputCPF',
        'CPFField': 'BaseInputCPF',
        'CnpjField': 'BaseInputCNPJ',
        'CNPJField': 'BaseInputCNPJ',
        'CpfCnpjField': 'BaseInputCPF',
        'SelectField': 'BaseSelect',
        'MultiselectField': 'BaseMultiselect',
        'AutocompleteField': 'BaseSelect',
        'StateField': 'BaseSelect',
        'RadioField': 'BaseRadio',
        'CheckboxField': 'BaseRadio',
        'ToggleField': 'BaseRadio',
        'CheckboxSingleField': 'BaseRadio',
        'TermsField': 'BaseRadio',
        'DateField': 'BaseInputDate',
        'TimeField': 'BaseInputDate',
        'DatetimeField': 'BaseInputDate',
        'BirthdateField': 'BaseInputDate',
        'FileField': 'BaseInput',
        'ImageField': 'BaseInput',
        'SignatureField': 'BaseInput',
        'FacialField': 'BaseInput'
      }
      return componentMap[componentName] || 'BaseInput'
    },

    // ---- Save ----

    async saveCompanion () {
      this.submitted = true

      if (this.errorCPF) {
        errorMessage('CPF informado é inválido.')
        return
      }

      this.loading = true
      try {
        const payload = {
          participant_id: this.idParticipant
        }

        if (this.hasCardBuilder) {
          // Extrai campos standard e custom dos valores preenchidos
          const cv = this.customDataValues
          payload.name = cv.name || null
          payload.email = cv.email || null
          payload.phone = cv.phone || null
          payload.cpf = cv.cpf || null
          payload.birth_date = cv.birth_date || null
          payload.gender = cv.gender || null
          payload.address = cv.address || null
          payload.city = cv.city || null
          payload.state = cv.state || null
          payload.zip_code = cv.zip_code || null
          payload.custom_data = cv
        } else {
          payload.name = this.companion.name
          payload.email = this.companion.email
          payload.phone = this.companion.phone
          payload.cpf = this.companion.cpf
          payload.birth_date = this.companion.birth_date
        }

        if (!payload.name || !payload.email) {
          errorMessage('Preencha os campos obrigatórios (Nome e E-mail).')
          this.loading = false
          return
        }

        await http.post('/admin/companions', payload)

        successMessage('Sucesso: Acompanhante cadastrado com sucesso.', 2500)
        this.close()
        this.$emit('created')
      } catch (err) {
        const msg = err.response && err.response.data && err.response.data.message
          ? err.response.data.message
          : err.message
        errorMessage('Alerta: ' + msg)
      } finally {
        this.loading = false
      }
    },
    close () {
      this.modal = false
      this.companion = {}
      this.customDataValues = {}
      this.participantCard = null
      this.submitted = false
      this.errorCPF = false
    }
  },
  watch: {
    modal () {
      if (!this.modal) {
        this.close()
      }
    }
  }
}
</script>
<style scoped>
.vld-overlay.is-full-page {
    z-index: 1051 !important;
}
.modal-header {
  background: #000 !important;
  color: #fff;
}
</style>
